<template>
    <div class="subPage">
        <div class="model">
            <div class="model_header">
                <img :src="course.course.midCover ?
                        course.course.midCover :
                        '../../static/img/default.png'
                    " class="miniCover">
            </div>
            <div class="model_body">
                <p class="title">{{ course.course.title }}</p>
                <p class="subTitle">{{ course.course.subTitle }}</p>
                <div class="flexContainer">
                    <p class="price">￥{{ ((course.course.price / 100 || 0)).toFixed(2) }}</p>
                    <p class="magicStudentNum">{{
                        course.action.magicStudentNum
                        }}人在学</p>
                </div>
                <div>
                    <div class="marks">
                        <p class="mark">{{ course.action.currentStatusInfo }}</p>
                        <div class="markTab">
                            <div v-for="(item, index) in course.marks" :key="item.title">
                                <span :class="`mark${index}`">{{ item.title }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="model">
            <div v-for="(item, index) in course.course.multiContent.contents" :key="`${item.dex}--${index}`">
                <div class="words" v-if="item.type === 'words'">
                    <a v-html="item.value" :class="item.style" :href="item.clickLink ? item.clickLink : 'javascript:;'">
                      </a>
                  <!--用pre标签，开头空格不显示-->
                </div>
                <div class="video" v-if="item.type === 'video'">
                    <video class="coverVideo" :src="item.value" controls preload="auto" :poster="item.cover" x5-video-player-fullscreen="true" webkit-playsinline="true" x-webkit-airplay="true" playsinline="true" x5-playsinline></video>
                </div>
                <div class="voice" v-if="item.type === 'voice'">
                    <audio :src="item.value" controls></audio>
                </div>
                <div class="pic" v-if="item.type === 'pic'">
                    <a :href="item.clickLink ? item.clickLink : 'javascript:;'">
                        <img :src="item.value" />
                    </a>
                </div>
            </div>
        </div>
        <div style="height: 60px"></div>
      <!-- 学习 -->
        <div class="operation btn-fix" v-if="mineCourse.buy" >
          <mt-button  class="share" @click="$router.push('/user/channel')">推荐有奖</mt-button>
          <mt-button  class="learn" @click="toLearn(course.course.id)">去学习</mt-button>
        </div>
        <!-- 购买 mineCourse.buy-->
        <div  v-if="!mineCourse.buy" class="btn-fix">
          <mt-button v-if="course && course.stock && course.stock.unUsedNum > 20" class="buy" @click="createCourse(course.course.id)">购买课程</mt-button>
          <mt-button v-if="course && course.stock && course.stock.unUsedNum <= 20" disabled class="buy">已售罄</mt-button>
        </div>

      <go-back-home/>
    </div>
</template>

<script>
import { getQueryString } from '../../utils/utils';
import SiteEnv from '../../utils/siteEnv';
import { mapGetters, mapActions } from 'vuex';

let baseInfo = SiteEnv.showSiteBase();

let resolveShare;

export default {
  name: 'SchoolDetail',
  meta:{page:true},
  computed: {
    ...mapGetters('school', {
      course: 'getCourse',
      mineCourse: 'getMineCourse',
    }),
  },
  customShare() {
    return new Promise(resolve => (resolveShare = resolve));
  },
  filters: {

  },
  props: ['courseId'],
  watch: {
    course: {
      handler: function (course) {
        let _this = this;
        if(course && course.course && course.course.multiContent &&
          course.course.multiContent.contents.length) {
          let list = course.course.multiContent.contents;
          list.forEach(item => {
            item.value = _this.replaceNewLine(item.value);
          })
        }
      },
      deep: true
    },
  },
  data() {
    return {
    }
  },
  methods: {
    ...mapActions('school', ['createCourse', 'toLearn']),
    replaceNewLine(value) {
      if (!value) return value
      value = value.replace(/(\r\n)|(\n)/g,'<br/>');
      value = value.replace(/ /g,"&nbsp;");
      return value;
    }
  },
  created() {
    this.$store.dispatch('school/getCourse', this.courseId).then(() => {
      resolveShare({
        title: `${this.course.course.title} ${baseInfo.mottoTitle}`,
        pic: this.course.course.miniCover,
        summary: `${this.course.course.subTitle} ${baseInfo.mottoContent}`,
        url: location.href,
      });
    });
    //TODO yuyi 拿到课程数据时显示课程的title 超过11个字的换成前十加 …
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.operation {
  display: flex;
  justify-content: space-around;
}
.btn-fix {
  width: 100%;
  position: fixed;
  bottom: 0;
  height: 57px;
  z-index: 10;
  background-color: #F3F3F3;
  padding-top: 10px;
}
.coverVideo {
  object-fit: cover;
  object-position: center center;
}
.share {
  color: #009688;
  border: 1px solid #009688;
  width: 35%;
}
.learn {
  color: #fff;
  border: 1px solid #009688;
  background: #009688;
  width: 50%;
}
.buy {
  background: #009688;
  color: #fff;
  width: 90%;
}
/* 三种样式 */
.important {
  font-size: 0.14rem !important;
}
.general {
  font-size: 0.13rem !important;
}
.slight {
  font-size: 0.12rem !important;
}
.words {
  padding: 0.04rem 0.16rem;
  font-size: 0.16rem;
  text-align: left;
  color: #7e7e7e;
}
.words p {
  font-weight: 600;
}
.words a {
  color: #000;
  word-wrap: break-word;
}
.video {
  padding: 0.04rem 0.16rem;
  font-size: 0.16rem;
  text-align: left;
  color: #000;
}
.video p {
  font-weight: 600;
}
.video video {
  width: 100%;
}
.voice {
  padding: 0.04rem 0.16rem;
  font-size: 0.16rem;
  text-align: left;
  color: #000;
}
.voice p {
  font-weight: 600;
}
.voice audio {
  width: 100%;
}
.pic {
  padding: 0.04rem 0.16rem;
  font-size: 0.16rem;
  text-align: left;
  color: #000;
}
.pic p {
  font-weight: 600;
}
.pic img {
  width: 100%;
}
.markTab {
  display: flex;
  float: right;
}
.markTab div {
  margin-right: 0.05rem;
}
.marks {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}
.mark {
  color: #009688;
}
.flexContainer {
  display: flex;
  justify-content: space-between;
}
.title {
  color: #000;
  font-size: 0.16rem;
  font-weight: 600;
  padding: 0.1rem 0 0.05rem 0;
}
.magicStudentNum {
  padding: 0.1rem 0;
  color: #7f7f7f;
}
.price {
  font-size: 0.16rem;
  color: #ffc107;
  padding: 0.1rem 0;
}
.magicStudentNum {
}
.subPage {
  text-align: center;
  margin-top: 0.1rem !important;
}
.miniCover {
  width: 100%;
  height: 100%;
}
.model_header {
  height: 1.28rem;
  padding: 0;
  border: none;
}
.model_body {
  background: #fff;
  height: unset;
  text-align: left;
}
.model {
  height: unset;
  width: 90%;
  display: inline-block;
  margin: 2%;
}
.doubleLine {
  display: flex;
}
.mark0 {
  color: #ff1f3b;
  background: #ffa2ae;
  border: 1px solid #ff1f3b;
  padding: 0.03rem;
  border-radius: 10px;
  padding-left: 0.05rem;
  padding-right: 0.05rem;
}
.mark1 {
  background: #fff1c5;
  color: #fec100;
  border: 1px solid #fec100;
  padding: 0.03rem;
  border-radius: 10px;
  padding-left: 0.05rem;
  padding-right: 0.05rem;
}
.mark2 {
  color: #6bb51b;
  background: #7ed321;
  border: 1px solid #6bb51b;
  padding: 0.03rem;
  border-radius: 10px;
  padding-left: 0.05rem;
  padding-right: 0.05rem;
}
.mark3 {
  color: #009688;
  background: #d6eeec;
  border: 1px solid #009688;
  padding: 0.03rem;
  border-radius: 10px;
  padding-left: 0.05rem;
  padding-right: 0.05rem;
}
.mark4 {
  color: #ff1f3b;
  background: #ffa2ae;
  border: 1px solid #ff1f3b;
  padding: 0.03rem;
  border-radius: 10px;
  padding-left: 0.05rem;
  padding-right: 0.05rem;
}
.mark5 {
  background: #fff1c5;
  color: #fec100;
  border: 1px solid #fec100;
  padding: 0.03rem;
  border-radius: 10px;
  padding-left: 0.05rem;
  padding-right: 0.05rem;
}
.mark6 {
  color: #6bb51b;
  background: #7ed321;
  border: 1px solid #6bb51b;
  padding: 0.03rem;
  border-radius: 10px;
  padding-left: 0.05rem;
  padding-right: 0.05rem;
}
</style>



// WEBPACK FOOTER //
// src/components/page/SchoolDetail.vue